<template>
	<div>
		<a-modal id='operationbiezhu' width='40rem' v-model="visible" on-ok="handleOk1"
			v-dragModal :dialog-style="{ top:'15vh' }"
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 38rem;margin: 1rem 1rem 0 1rem;text-align: center;">備 註</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="paddingBottom: 1rem;padding: 1rem;background-color: #fff;width: 38rem;margin: 0 auto;">
				<div style="padding-top: 0.5rem;">
					<div style="display: flex;justify-content: space-between;">
						<a-form-model ref='form' :model="form"  layout='inline' hideRequiredMark>
									<a-form-model-item label='備註日期' >
										<a-date-picker placeholder='' v-model='params.createtime' @change='fanhand'/>
									</a-form-model-item>
						</a-form-model>
						<div style="font-size: .8rem;color: #000;margin-top: .5rem;">操作人員：{{items.name}} </div>
					</div>
					<div style='height: 21rem;overflow-y: auto;' id='crelll'>
						<a-collapse :bordered="false" expand-icon-position="right" v-model='value'>
						      <a-collapse-panel :key="ind" v-for='(item,ind) in columnsData'>
								<div slot='header' class='div_w'>{{item.timestr}}</div>
						        <p v-for='(val,ind) in item.remarkList' style='display: flex;justify-content: space-between;margin:0;padding: .5rem 0;'
								:style='{borderBottom:ind<item.remarkList.length-1?"1px solid #ddd":""}'>
								<span style='display: inline-block;width: 75%;'>{{val.remark}}</span><span>{{val.timestr}}</span></p>
						      </a-collapse-panel>
						    </a-collapse>
					</div>
					<div class="paginationView" v-if='params.pages>1'>
						<div style="flex-shrink: 0;">第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
						<div style="margin:auto;">
							<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
								:pageSize="params.perPage" />
						</div>
						<div class="pageTzView">
							<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
							<span @click="tzEvent" style="    flex-shrink: 0;">跳轉</span>
						</div>
					</div>
					</div></div>
					<div style="paddingBottom: 1rem;border-radius: 0 0 10px 10px;padding: 1rem;background-color: #fff;
					width: 38rem;margin: 0 auto;marginBottom: 1rem;border: 1px solid #e5e5e5;">
					<div style="display:flex;align-items:center;">
						<a-input v-model="form.remark" type="textarea" placeholder='请输入'/>
						<button class='btn1 btnx' @click='handbect("form")'  v-html='"保&nbsp;&nbsp;存"'></button>
					</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['items'],
		data() {
			return {
				value:[],
				columns: [
					{
						title: '操作模塊',
						dataIndex: 'name_en',
						align: 'center',
						width: '25%'
					},
					{
						title: '操作權限',
						dataIndex: '',
						align: 'center',
						width: '25%',
						scopedSlots: {
							customRender: 'email'
						}
					},
					{
						title: '操作信息',
						dataIndex: 'job',
						align: 'center',
						width: '25%',
					},
					{
						title: '操作時間',
						dataIndex: 'position',
						align: 'center',
						width: '25%',
					}
				],
				visible: true,
				rules: {
					email:[{required:true,message:' ',trigger:'blur'}],
					position:[{required:true,message:' ',trigger:'change'}],
					system_type:[{required:true,message:' ',trigger:'change'}],
					name:[{required:true,message:' ',trigger:'blur'}],
				},
				tzPageNum:'',
				form:{
					remark:'',
					data:''
				},
				columnsData:[],
				params: {
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					perPage: 20, //每頁條目數
					createtime: '',
				},
			}
		},
		watch:{
			value:{
				deep:true,
				handler(){
					console.log(this.value)
				}
			}
		},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * 20;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum * 20;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},
		},
		mounted() {
			// if(this.items){
			// 	this.handz()
			// }

			// this.getdata()
			this.messLoad();
		},
		methods: {
			fanhand(val) {
				this.params.createtime = this.params.createtime ? App.oDate.secsTime3(this.params.createtime._d) : '';
				this.messLoad();
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.messLoad();
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.messLoad();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			messLoad() {
				let obj = JSON.parse(JSON.stringify(this.params))
				obj['adminid'] = this.items['adminid']
				this.$ajax({
					method: 'post',
					url: this.$api.getSuperAdminRemarks,
					headers: {
						token: this.$store.state.token
					},
					data: obj
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.columnsData = res.data.result
						let arr = []
						this.columnsData.map((ev,a)=>{
							if(ev.remarkList){
								arr.push(a)
							}
						})
						this.value = arr
						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
						this.params.missionnum = res.data.missionnum
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			emailfn() {
				if (this.form.email) {
					var t = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/;
					if (!(t.test(this.form.email))) {
						this.form.email = ''
						this.$message.warning('請輸入正確的電郵地址')
					}
				}
			},
			getdata() {
				this.$ajax({
				method: 'post',
					url: this.$api.getParamList,
					data: {
						 "type":"position"
					}
				}).then(res => {
					if (res.data) {
						this.domainlist = res.data.result
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}})
			},
			handz(val) {
				let obj = JSON.parse(JSON.stringify(this.form))
				obj['adminid'] = this.items['adminid']
				this.$ajax({
					method: 'post',
					url: this.$api.newAdminUser,
					data:obj
				}).then(res => {
					if (res.data) {
						this.form = res.data
						// App.oTool.successT();
						console.log(this.form)
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				// this.handz()
			},
			//下单
			handbect(ruleForm) {
				if(this.form.remark){
					this.form.pageNum = 1;
					let obj = JSON.parse(JSON.stringify(this.form))
					obj['token'] = this.$store.state.token;
					obj['adminid'] = this.items['adminid']
					this.$ajax({
						method:'post',
						url :this.$api.newSuperAdminRemarks,
						data:obj
					}).then(res=>{
						if(res.data.qmiscode == 1000){
							App.oTool.successT();
							// this.$emit('child', 1)
							this.form.remark = ''
							this.messLoad();
						}else{
							this.$api.warning(res.data.qmismsg)
						}
					})
				}
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			}
		}
	}
</script>

<style lang="scss">
	#crelll::-webkit-scrollbar{
		display: none;
	}
	/* 分頁樣式 */
	#operationbiezhu .paginationView {
	    padding-top: 1rem;
	    display: flex;
	    align-items: center;
	    width: 100%;
	    color: #666666;
		/* height:calc(100vh - 142px); */
	}
	
	#operationbiezhu .ant-pagination-item {
	    background-color: #fff;
	    border-color: #bfbfbf;
	    color: #999999;
	    margin-right: 0.5rem;
	}
	
	#operationbiezhu .ant-pagination-prev {
	    margin-right: 1rem;
	}
	
	#operationbiezhu .ant-pagination-item a {
	    color: inherit;
	}
	
	#operationbiezhu .ant-pagination-item-active {
	    background-color: #f3f3f3;
	    border-color: #d8d8d8;
	    color: #000;
	}
	
	#operationbiezhu .ant-pagination-prev .ant-pagination-item-link,
	#operationbiezhu .ant-pagination-next .ant-pagination-item-link {
	    background-color: #fff;
	    color: #666666;
	    border: 1px solid #bfbfbf;
	}
	
	#operationbiezhu .ant-pagination-disabled a,
	#operationbiezhu .ant-pagination-disabled:hover a,
	#operationbiezhu .ant-pagination-disabled:focus a,
	#operationbiezhu .ant-pagination-disabled .ant-pagination-item-link,
	#operationbiezhu .ant-pagination-disabled:hover .ant-pagination-item-link,
	#operationbiezhu .ant-pagination-disabled:focus .ant-pagination-item-link {
	    background-color: #d8d8d8!important;
	    color: #fff!important;
	}
	
	#operationbiezhu .pageTzView {
	    display: flex;
	    align-items: center;
	    margin-left: 0.7rem;
	}
	
	#operationbiezhu .pageTzView input {
	    width: 2.6rem;
	    height: 1.67rem;
	    border: 1px solid #bfbfbf;
	    outline: unset;
	    margin-right: 0.25rem;
	    border-radius: 4px;
	    text-align: center;
	}
	
	#operationbiezhu .pageTzView span {
	    background-color: #d8d8d8;
	    border-radius: 4px;
	    height: 1.67rem;
	    color: #666666;
	    padding: 0 0.625rem;
	    line-height: 1.67rem;
	}
	.mark-file {
		position: absolute;
		top: 0;
		left: 0;

		div {
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	#operationbiezhu {
		.div_w{
			border-left: 5px solid #0C8B97;
			color: #0C8B97;
			padding-left: 5px;
			font-size: 0.8rem;
		}
		.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header {
		    padding: 12px 16px 10px 0px;
		}
		.ant-collapse-content > .ant-collapse-content-box {
		    padding: 0px 16px 4px 10px;
		}
		.ant-collapse-borderless{
			background-color: #fff;
		}
		.ant-collapse-borderless > .ant-collapse-item {
		    border-bottom: 1px solid #fff;
		}
		.ant-table-thead > tr > th, .ant-table-tbody > tr > td{
			    padding: 8px;
		}
		.ant-form-explain{
			display: none;
		}

		.ant-form-item, .ant-form-item-control{
			width: 100%;
		}
		
		.ant-form-item-control-wrapper{
			.ant-form-item-control{
				width: 100%;
			}
		}

		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}


		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item label {
			font-size: .8rem !important;
		}

		.ant-input {
			font-size: .8rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .8rem !important;
		}

		.ant-form-item-children {
			font-size: .8rem !important;
		}

		.ant-modal-body {
			background-color: #e5e5e5 !important;
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 7rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin-left: 1rem;
		}

		.btnx {
			background-color: #0c8b97;
		}
	}
</style>
